import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import Logo from './Logo';

/** Full-height branded loader — used as the Suspense fallback for lazy routes. */
export default function LoadingScreen({ height = '70vh', label = 'Loading…' }) {
  return (
    <Box sx={{ height, display: 'grid', placeItems: 'center' }}>
      <Stack alignItems="center" spacing={2.5}>
        <Box sx={{ position: 'relative', display: 'grid', placeItems: 'center' }}>
          <CircularProgress size={68} thickness={2.5} />
          <Box sx={{ position: 'absolute' }}>
            <Logo showWordmark={false} size={30} />
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    </Box>
  );
}
